import { Button } from 'primereact/button';
import breadcrumbleft from "../../Assets/breadcrumbleft.png";
const ModalHeader = ({ onClose, backText }) => {
    return (
      <Button
        link
        onClick={onClose}
        className="text-base font-semibold text-blue-900"
      >
        <span className="chevronlefticonclass">
          <img src={breadcrumbleft} alt="Back arrow" />
        </span>
        {backText}
      </Button>
    )
}

export default ModalHeader;
